import { render, staticRenderFns } from "./TruckSighting.vue?vue&type=template&id=7f995366&scoped=true&"
import script from "./TruckSighting.vue?vue&type=script&lang=js&"
export * from "./TruckSighting.vue?vue&type=script&lang=js&"
import style0 from "./TruckSighting.vue?vue&type=style&index=0&id=7f995366&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f995366",
  null
  
)

export default component.exports